
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-437213ba\",\"scoped\":false,\"hasInlineConfig\":false}!../../vue-loader/lib/selector?type=styles&index=0!./RingLoader.vue")

var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./RingLoader.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-437213ba\"}!../../vue-loader/lib/selector?type=template&index=0!./RingLoader.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-spinner/src/RingLoader.vue
// module id = 160
// module chunks = 0